import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const GrayButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-gray-button">
      {children}
    </IfmsButton>
  );
});

GrayButton.defaultProps = {
};

GrayButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(GrayButton);

